import { Spinner } from '@capturi/ui-components'

const Loader = <Spinner display="block" m="5rem auto" />

export default Loader
